import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { Spin, Menu } from 'antd';
import { get } from 'lodash';

import IconFont from '@/components/IconFont';
import { initSubmenu } from '@/redux/actions/user';
import storage from '@/utils/storage';

import { MenuItem } from './config/interface';
import styles from './header.module.scss';

function HeaderMenu(props) {
  const { submenus, menus, currentEmployeeLoading } = props;
  const [selectedKeys, setSelectedKeys] = useState([]);
  const history = useHistory();
  const location = useLocation();

  const [childSelectedKeys, setChildSelectedKeys] = useState([]);

  const [hoveredItem, setHoveredItem] = useState<MenuItem | null>(null);

  const locateMenu = (menu: MenuItem, isChild: boolean = false, children?: any[]) => {
    setSelectedKeys([`${menu.id}`]);
    // cache submenus into redux
    const childrenMenus = isChild ? children : menu.children;
    if (childrenMenus && Array.isArray(childrenMenus) && childrenMenus.length > 0) {
      props.initSubmenu({ submenus: childrenMenus });
    } else {
      props.initSubmenu({ submenus: [] });
    }
  };

  const redirectMenu = (menu: MenuItem, isChild: boolean = false, children?: any[]) => {
    const defaultPath = !isChild ? get(menu, 'children.[0].path') : menu.path;
    if (defaultPath) {
      history.push(defaultPath);
    }
  };

  const handleClickMenu = (menu: MenuItem, isChild: boolean = false, children?: any[]) => {
    // 菜单切换
    const { pathname } = location;
    console.log('handleClickMenu', pathname, menu.path, menu);
    // if (pathname.includes(menu.path)) {
    //   return;
    // }
    if (pathname === menu.path) {
      return;
    }
    // 清除订单列表点击详情存储的数据影响
    storage.delete('ORDER-LIST-STATUS');

    if (isChild) {
      locateMenu(menu, isChild, children);
      redirectMenu(menu, isChild, children);

      setChildSelectedKeys([menu.id]);
      return;
    }
    locateMenu(menu);
    redirectMenu(menu);
  };

  // init active menus
  const initActiveMenu = (menuList: Array<MenuItem>, pathname) => {
    for (let i = 0, len = menuList?.length; i < len; i++) {
      const m = menuList[i];
      if (pathname.includes(m.path)) {
        locateMenu(m);
        if (pathname === m.path) {
          redirectMenu(m);
        }
      }
    }
  };

  // watch route change
  useEffect(() => {
    if (Array.isArray(menus)) {
      const { pathname } = location;
      initActiveMenu(menus, pathname);
    }
  }, [location, menus]);

  // init child active menus
  const locateChildMenu = (menu) => {
    setChildSelectedKeys([menu.id]);
  };
  const initChildActiveMenu = (menuList: Array<MenuItem>, pathname) => {
    if (!Array.isArray(menuList) || menuList.length === 0) return;

    for (let i = 0, len = menuList?.length; i < len; i++) {
      if (menuList[i].visible === 1) {
        if (pathname === menuList[i].path) {
          locateChildMenu(menuList[i]);
          break;
        }
        if (pathname.includes(menuList[i].path)) {
          locateChildMenu(menuList[i]);
          // recursive activate children menus
          initChildActiveMenu(menuList[i].children, pathname);
        }
      }
    }
  };
  // watch submenus change
  useEffect(() => {
    const { pathname } = location;
    console.log('*****---aside----submenus', submenus, pathname);
    initChildActiveMenu(submenus, pathname);
  }, [submenus]);

  const renderSubMenu = (menuList: Array<MenuItem>, parentKey: any) => {
    return menuList.map((m) => {
      if (m.visible !== 1) return null; // visible: 0（不可见）、1（可见）、2（侧边栏不可见）
      const activeMenu = childSelectedKeys.includes(m.id);

      return (
        <Menu.Item
          className={`${styles.headerSubMenuItem} ${activeMenu ? styles.activeMenu : null}`}
          key={`${parentKey}-${m.id}`}
          icon={null}
          onClick={() => handleClickMenu(m, true, menuList)}
        >
          {m.name}
        </Menu.Item>
      );
    });
  };

  const renderMenus = (menuList: Array<MenuItem>) => {
    if (Array.isArray(menuList)) {
      return menuList.map((m) => (
        <Menu.SubMenu
          className={styles.headerMenuItem}
          key={m.id}
          title={m.name}
          onTitleClick={() => handleClickMenu(m)}
          onMouseEnter={() => setHoveredItem(m)}
          onMouseLeave={() => setHoveredItem(null)}
        >
          {hoveredItem?.id === m?.id &&
          m.children &&
          Array.isArray(m.children) &&
          m.children.length > 0
            ? renderSubMenu(m.children, m.id)
            : null}
        </Menu.SubMenu>
      ));
    }
    return null;
  };

  return (
    <div className={styles.headerMenu}>
      <Spin size="small" spinning={currentEmployeeLoading}>
        <Menu mode="horizontal" selectedKeys={selectedKeys}>
          {renderMenus(menus)}
        </Menu>
      </Spin>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { submenus, menus, currentEmployeeLoading } = state.user;
  return { submenus, menus, currentEmployeeLoading };
};

export default connect(mapStateToProps, {
  initSubmenu,
})(HeaderMenu);
